// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"32627e43","646":"6a7defff","709":"8430fbcd"}[chunkId] + ".chunk.css";
};